import React from 'react';
import {AppText, AppErrorText} from './Typography';
import {useAuthorization} from '../../../features/auth/hooks/useAuthorization';

interface AppInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  /** Permission required to edit this input */
  permission?: string;
  /** Show input as disabled instead of hiding when no permission */
  showDisabled?: boolean;
  /** Custom disabled message */
  disabledMessage?: string;
}

const AppInput: React.FC<AppInputProps> = ({
  label,
  error,
  className = '',
  permission,
  showDisabled = false,
  disabledMessage = 'لا يمكن التعديل',
  disabled,
  ...props
}) => {
  const {hasPermission} = useAuthorization();

  const canEdit = !permission || hasPermission(permission);
  const isDisabled = disabled || !canEdit;

  return (
    <div className="w-full relative">
      {label && <AppText className="block mb-2 font-bold">{label}</AppText>}
      <input
        className={`w-full rounded-xl border bg-white px-4 py-3 text-lg font-normal text-grayText font-zain outline-none transition-all
          ${error ? 'border-red-500' : 'border-gray-200 focus:border-gray-500'}
          placeholder-gray-400
          ${isDisabled && showDisabled ? 'opacity-50 cursor-not-allowed' : ''}
          ${className}`}
        disabled={isDisabled}
        {...props}
      />
      {!canEdit && showDisabled && (
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <span className="text-xs text-gray-500 bg-white px-2 py-1 rounded shadow-sm border">
            {disabledMessage}
          </span>
        </div>
      )}
      {error && <AppErrorText className="text-sm mt-2">{error}</AppErrorText>}
    </div>
  );
};

export default AppInput;
